// ENG2-2461: edit the date the customer's Nordic lookup contract year starts,
// and show the current period. Presentational; the container saves.

import * as React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'
import CustomDateInput from '../inputs/custom-date-input'
import { NordicPeriod, formatPeriod } from '../nordic-contract-year'

type Props = {
  startDate: string | null
  period: NordicPeriod | null
  isSaving: boolean
  onChangeStartDate: (isoDate: string) => void
}

function NordicContractYearPanel({
  startDate,
  period,
  isSaving,
  onChangeStartDate,
}: Props) {
  return (
    <Paper
      variant="outlined"
      sx={{ width: '100%', borderRadius: 2, overflow: 'hidden' }}
      data-testid="nordic-contract-year"
    >
      <Box
        sx={{
          px: 3,
          py: 2,
          bgcolor: 'action.hover',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          Nordic lookups contract year
        </Typography>
      </Box>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={3}
        alignItems={{ xs: 'stretch', sm: 'flex-start' }}
        sx={{ p: 3 }}
      >
        <Box sx={{ width: { xs: '100%', sm: 260 } }}>
          {/* Not clearable: RisikaAPI re-anchors a missing date on the next
              lookup, which would silently restart the customer's year. */}
          <CustomDateInput
            value={startDate}
            label="Nordic subscription start date"
            isLoading={isSaving}
            allowClear={false}
            onChange={(isoDate) => {
              if (isoDate) onChangeStartDate(isoDate)
            }}
          />
        </Box>
        <Stack spacing={0.75} sx={{ minWidth: 0 }}>
          {period && (
            <Typography variant="body2">
              Current period: {formatPeriod(period)}
            </Typography>
          )}
          {!period && !startDate && (
            <Typography variant="body2">
              No start date yet: this customer&apos;s Nordic lookups are not
              counted until you enter one.
            </Typography>
          )}
          {!period && startDate && (
            <Typography variant="body2">
              Lookups are counted from this date once the customer&apos;s
              package limit applies.
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">
            Each Nordic company counts once per contract year. Moving the start
            date starts a new count from that date; the used count on the Nordic
            lookups row updates on the customer&apos;s next lookup.
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  )
}

export default NordicContractYearPanel
